import { Settings, WidgetData } from './data'
import { Widget } from './widget'

export interface SlideT {
  heading: string
  background_image: {
    url: string
    alt: string
  }
  button_text: string
  description: string
  link: {
    url: string
  }
}

export type SlidesData = WidgetData & {
  settings: Settings & {
    slides: SlideT[]
  }
  widgetType: 'slides'
}

export class SlidesWidget extends Widget {
  slides: SlideT[]

  constructor (data: SlidesData) {
    super(data)
    this.slides = data.settings.slides
  }
}
